import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lastLogin',
})
export class LastLoginPipe implements PipeTransform {

  transform(value: Date): any {
    if (value) {
      const datePipe = new DatePipe('en-US');
      const castedValue = new Date(value);
      // set the timezone of the local user.
      const clientDate = new Date(castedValue.getTime() - castedValue.getTimezoneOffset() * 60000);
      return datePipe.transform(clientDate, 'MMM d, y, h:mm a O');
    }
    return '-';
  }

}
